import { OrganizationUserRole } from "../userOrganizationRoles";
import { UserWorkspaceRole } from "../userWorkspaceRoles";

export const ORGANIZATION_ADMIN_ROLES: OrganizationUserRole[] = [
    OrganizationUserRole.ADMIN,
    OrganizationUserRole.OWNER,
];

export const ORGANIZATION_ROLE_TO_OWNED_WORKSPACE_ROLE: Record<
    OrganizationUserRole,
    UserWorkspaceRole
> = {
    [OrganizationUserRole.OWNER]: UserWorkspaceRole.PRIMARY_ADMIN,
    [OrganizationUserRole.ADMIN]: UserWorkspaceRole.ADMIN,
    [OrganizationUserRole.MANAGER]: UserWorkspaceRole.ADMIN,
    [OrganizationUserRole.MEMBER]: UserWorkspaceRole.ACCOUNTANT,
};

export const ORGANIZATION_ROLE_TO_WORKSPACE_ROLE: Record<
    OrganizationUserRole,
    UserWorkspaceRole
> = {
    [OrganizationUserRole.OWNER]: UserWorkspaceRole.ADMIN,
    [OrganizationUserRole.ADMIN]: UserWorkspaceRole.ADMIN,
    [OrganizationUserRole.MANAGER]: UserWorkspaceRole.ADMIN,
    [OrganizationUserRole.MEMBER]: UserWorkspaceRole.ACCOUNTANT,
};

/** Sentinel value used in UI filter dropdowns to represent "No tier" (null serviceId). */
export const NO_TIER_SENTINEL = "NO_TIER";

export const MAX_ORGANIZATION_LOGO_FILE_SIZE_MB = 2;
export const MAX_ORGANIZATION_LOGO_FILE_SIZE_BYTES =
    MAX_ORGANIZATION_LOGO_FILE_SIZE_MB * 1024 * 1024;
